import { LinkedDoorOrderItem, OrderItem, SupplierOrderItem } from "../../types";
import { isLinkedDoorItem } from "../order_item/isLinkedDoorItem";

export function filterLinkedDoorItems(items: OrderItem[], options: {strict:boolean} = {strict: true}): LinkedDoorOrderItem[] {
	return items
		.filter(isLinkedDoorItem)
		.filter(
			(item) =>
				item.type === "SUPPLIER" &&
				item.supplierOrderItemType === "LINKED_DOOR" &&
				(options.strict ? item.parentId : true) &&
				(options.strict ? items.find((i) => i.id === item.parentId) : true)
		);
}
